
<template>
  <v-card>
    <v-card-title v-show="!noHeading"> Premium Screens </v-card-title>
    <v-card-text>
      <v-row no-gutters>
        <v-col cols="12" sm="6" v-for="(col, i) in cols" :key="`ps-${i}`">
          <v-list class="" two-line>
            <v-list-item
              :key="screen.slug"
              v-for="screen in col"
              @click="loadScreener(screen)"
            >
              <v-icon left color="primary" v-if="screen.lock"
                >mdi-lock-outline</v-icon
              >
              <v-list-item-content>
                <div>{{ screen.name }}</div>
                <div class="grey--text caption">{{ screen.description }}</div>
              </v-list-item-content>
              <v-icon
                v-show="selectedSlug == screen.slug"
                small
                color="primary"
              >
                mdi-checkbox-marked-circle-outline</v-icon
              >
            </v-list-item>
          </v-list>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "AllScreens",
  props: { noHeading: { type: Boolean } },
  data: () => ({
    screens: {},
  }),
  methods: {
    loadScreener({ slug, name, lock }) {
      if (lock) {
        this.$root.$subscribe.open();
        return;
      }
      this.$store.commit("setScreener", { slug, name, custom: false });
    },
  },
  computed: {
    cols() {
      let premiumScreeners =
        JSON.parse(JSON.stringify(this.$store.getters.screens["Full"])) || [];
      let col2 = premiumScreeners.splice(
        Math.ceil(premiumScreeners.length / 2)
      );
      return [premiumScreeners, col2];
    },
    selectedSlug() {
      return this.$store.getters.getScreenerId;
    },
  },
};
</script>